import { useMutation } from '@tanstack/react-query';
import { queryClient } from 'Context/QueryClientContext';
import ObrasApi from 'Data/Obras.api';
import { IObraResponse } from 'Data/interfaces/Obra/IObraListResponse';
import toastHandler from 'Utils/toastHandler';
import { OBRA_QUERY_KEY } from 'Data/keys/QueryKeys';
import { IDisciplineRequestDelete } from 'Data/interfaces/Obra/IDisciplineRequestDelete';

export const useQueryDeleteDiscipline = () => {
  const { mutate, isPending } = useMutation({
    mutationFn: (variables: IDisciplineRequestDelete) => {
      return ObrasApi.deleteDiscipline(variables);
    },
    onMutate: async (variables) => {
      const previousUniqueObra = queryClient.getQueryData<IObraResponse>(
        [OBRA_QUERY_KEY, Number(variables.ConstructionSiteId)],
      );

      queryClient.setQueryData<IObraResponse>(
        [OBRA_QUERY_KEY, Number(variables.ConstructionSiteId)],
        (old) => {
          if (old) {
            old.Disciplines = old.Disciplines.filter((discipline: any) => {
              return discipline.ConstructionSiteDisciplinesId !==
                variables.ConstructionSiteDisciplineId;
            });
          }
          return old;
        },
      );

      return { previousUniqueObra };
    },
    onSuccess: async () => {
      toastHandler.showSuccess('Disciplina removida com sucesso!');
    },
    onError: async (error: any, variables, context) => {
      await queryClient.cancelQueries({
        queryKey: [OBRA_QUERY_KEY, Number(variables.ConstructionSiteId)],
      });

      queryClient.setQueryData<IObraResponse>(
        [OBRA_QUERY_KEY, Number(variables.ConstructionSiteId)],
        context?.previousUniqueObra,
      );

      const errorMsg = error.errors
        ? error.errors[0].Message
        : 'Erro ao listar disciplinas';
      toastHandler.showError(errorMsg);
    },
  });

  return {
    deleteDiscipline: mutate,
    isLoading: isPending,
  };
};
